import styled from '@emotion/styled';

export const Overlay = styled.div`
    position: absolute;
    text-align: center;
    background: ${(p) => p.theme.color.blackAlpha75};
    width: 100%;
    height: 100%;
    z-index: 300;
    display: flex;
    justify-content: center;
    align-items: flex-start;
`;
